import { useLayoutEffect } from "react";

export const useLockBodyScroll = (isLocked) => {
  useLayoutEffect(() => {
    document.body.style.overflow = isLocked ? "hidden" : "";
  }, [isLocked]);
};
